<script setup lang="ts">
import type { Category } from '@/models'
import { i18n } from '@/i18n'
import { computed } from 'vue'
import { categoryColour } from '@/constants'

const t = i18n.global.t

const props = defineProps<{
  category: Category
  stage: number
  total: number
}>()

const categoryAndStageDescription = computed(() => {
  switch (props.category) {
    // There is no case for 'what' in the design
    case 'how':
      if (props.stage === 0) return t('stageDescriptionHow1')
      else if (props.stage === 1) return t('stageDescriptionHow1')
      else if (props.stage === 2) return t('stageDescriptionHow1')
    case 'who':
      if (props.stage === 0) return t('stageDescriptionWho1')
      else if (props.stage === 1) return t('stageDescriptionWho2')
    case 'where':
      if (props.stage === 0) return t('stageDescriptionWhere1')
      else if (props.stage === 1) return t('stageDescriptionWhere2')
    case 'when':
      if (props.stage === 0) return t('stageDescriptionWhen1')
    case 'challenges & opportunities':
      if (props.stage === 0) return t('stageDescriptionChallenge1')
    default:
      return ''
  }
})

const categoryBorder = computed(() => {
  return categoryColour(props.category)
})
</script>

<template>
  <div class="flex flex-col items-center text-center w-full">
    <p class="text-3xl">{{ t(categoryAndStageDescription) }}</p>
    <div class="flex flex-row items-center justify-center w-1/2 gap-2 pt-8">
      <div class="border-8 w-1/3" :class="categoryBorder.border"></div>
      <div
        v-if="total > 1"
        class="border-8 w-1/3"
        :class="[stage > 0 ? categoryBorder.border : categoryBorder.border + ' opacity-30']"
      ></div>
      <div
        v-if="total > 2"
        class="border-8 w-1/3"
        :class="[stage > 1 ? categoryBorder.border : categoryBorder.border + ' opacity-30']"
      ></div>
    </div>
  </div>
</template>
